// import AuthLayout from "../../components/";
import {
    Col,
    Image,
    Layout,
    Row
} from "antd";
import { ImageUrl } from "../../helpers/Function";
// import router from "next/router";

function Homepage() {



    return (
        <>
            {/* <Helmet>
                <title>Preschool Management Solutions & Facility Consulting in NYC</title>
                <meta name="description" content="Access expert management solutions, facility consulting, & maintenance strategies for preschool in New York City to empower your early education program." />
                <meta property="og:title" content="Preschool Management Solutions & Facility Consulting in NYC" />
                <meta property="og:description" content="Access expert management solutions, facility consulting, & maintenance strategies for preschool in New York City to empower your early education program." />
            </Helmet> */}
            <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c7.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Carpet Cleaning and Maintenance – Cleaning for Health</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The training focuses on the vital role carpets play in children’s health, classroom image, and the financial investment of organizations. Proper carpet maintenance and cleaning are essential for extending the carpet’s lifespan, improving its health, and preserving its appearance. The training program aims to equip maintenance staff with comprehensive carpet care theory and best practices for effective carpet cleaning. Participants will gain valuable insights into daily, interim, and restorative carpet cleaning methods, along with the appropriate equipment, chemicals, and tools required for each process.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c8.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Chemistry and Chemical Safety for Custodians</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The “Chemistry and Chemical Safety for Custodians” training is designed to equip custodians working in early care and education centers with essential knowledge and skills to handle chemicals safely and effectively. The primary objective of this training is to provide participants with a comprehensive understanding of the various types of chemicals used in their work environment, along with proper usage and storage practices. Participants will explore the differences between traditional and green cleaning products, understand chemical hazards, and recognize the potential health impacts associated with their use. The training covers common types of cleaning agents, their composition, and functioning, as well as the importance of pH and its application in everyday product usage. Additionally, participants will learn basic OSHA safety compliance, how to read safety data sheets, and create proper labels. The training concludes by offering workplace best practices for chemical use and storage, ensuring a safe and healthy environment for everyone.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c9.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Green Cleaning Products and Practices: Promoting Healthier Indoor Environment</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The training program is dedicated to unraveling the world of green cleaning products and practices. This training is a champion for the health and safety of children, staff, and custodians, with a clear focus on ushering in positive changes. This enlightening journey takes participants from conventional cleaning products to the realm of Green Products and Green Cleaning Best Practices. The training equips attendees with insights into the science underpinning the transition, as well as the links between chemical toxins and childhood and staff illnesses.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c10.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Ground Rules for Custodians: Upholding Professional Conduct and Integrity in Child Care Settings</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Teachers, Assistant Teachers, Administrative and Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The Comprehensive Training on Infectious Diseases and Contagious Illnesses aims to equip participants with a deep understanding of bacteria, viruses, fungi, and parasites, as well as their modes of transmission. By delving into these topics, participants will gain valuable knowledge to effectively combat and prevent the spread of illnesses, including the coronavirus. The training content is carefully curated based on information provided by reputable sources such as the CDC (Centers for Disease Control), WHO (World Health Organization), NYSOCFS, DOH (Department of Health), and the National Health and Safety Performance Standards.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c11.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Introduction to Big Data for Custodians </h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The training program aims to empower custodial staff with the tools to actively contribute to the realm of continuous quality improvement within early care and education settings. The training’s primary objective is to illuminate how custodians play a vital role in upholding facility health and safety practices. By delving into the world of data, this training empowers custodians to harness the power of existing data to identify critical metrics that intricately influence the daily operation of the facility. Through this process, participants will master the art of compiling meaningful and insightful reports.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c12.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Mastering Inventory Control and Efficient Supply Ordering</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            This training program is meticulously designed to unravel the potential of inventory control systems. Harness the power of accuracy, optimal inventory levels, and informed decision-making, all converging to forge operational efficiency and substantial cost savings. This training program sets its sights on enhancing inventory control within programs. Dive into the essentials of people, processes, and product outcomes as they relate to inventory management. Explore an array of inventory management systems, encompassing stock ledgers, robust physical controls, insightful reporting mechanisms, and the innovative concept of just-in-time ordering.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c13.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Mastering Time, Task and Team Management for Custodians</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            This is a hands-on seminar designed to equip custodians with practical skills and insights to excel in the art of self management. By the end of this comprehensive training, attendees will possess a firm grasp of the policy and compliance elements that underpin effective custodial scheduling. Uncover the nuances between zone and team cleaning strategies, while also delving into the preparation and execution of task schedules. With a focus on optimizing efficiency and effectiveness, this training delves into best practices that are instrumental in elevating custodians’ performance. The supervisor’s role and essential tools are introduced, enabling participants to navigate the intricaties of daily, weekly, monthly, and annual tasks.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c14.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Planning & Managing for Successful Projects – Project Excellence: A Blueprint for Success</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            This training program unveils the fundamentals of orchestrating triumphant projects, regardless of their scale. This training is your gateway to mastering the art of defining, organizing, planning, executing, and ultimately closing projects. The complex world of project management is simplified into four distinctive phases, each pivotal to ensuring a seamless journey from project inception to completion. From crafting a written charter that sets the project’s foundation to establishing an actionable framework, transforming sizable tasks into manageable units, devising work schedules, exercising control, and culminating in a methodical closeout phase — this training covers it all.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c15.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Restroom Mainatenence – Cleaning for Health</h4>
                                        <p className="text-p-16">
                                            Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Teachers, Assistant Teachers, Administrative and Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The Comprehensive Training on Infectious Diseases and Contagious Illnesses aims to equip participants with a deep understanding of bacteria, viruses, fungi, and parasites, as well as their modes of transmission. By delving into these topics, participants will gain valuable knowledge to effectively combat and prevent the spread of illnesses, including the coronavirus. The training content is carefully curated based on information provided by reputable sources such as the CDC (Centers for Disease Control), WHO (World Health Organization), NYSOCFS, DOH (Department of Health), and the National Health and Safety Performance Standards.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={10}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c16.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={14}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>Vinyl Resilient Floor Maintenance</h4>
                                        <p className="text-p-16">
                                            Duration: 6 Hours
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                            Administrators, Custodial Supervisor
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                            The training is designed to equip participants with comprehensive knowledge and practical skills for successful floor maintenance, with a specific focus on vinyl floor care. The training aims to provide participants with a thorough understanding of floor care theory, problem-solving techniques, and practical applications. Participants will explore daily, interim, and floor restoration maintenance methods that optimize outcomes and increase productivity. The training delves into state-of-the-art floor care power equipment, chemicals, tools, and supplies, offering insights into the latest industry best practices. Including equipment and chemical safety. Participants will also gain familiarity with floor care concepts, terminology, and floor type identification to effectively address wear and appearance challenges.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>
            </Layout>
        </>
    );
}

export default Homepage;
